import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'

export const RecurringOrdersRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'recurring_orders',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/RecurringOrdersContainer').default

      const actions = require('./modules/recurring_orders').actions
      const reducer = require('./modules/recurring_orders').default

      injectReducer(store, { key: 'recurring_orders', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'recurring_orders')
  }
})

export const NewRecurringOrderRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'recurring_orders/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewRecurringOrderContainer').default

      const reducer = require('./modules/recurring_order').default

      injectReducer(store, { key: 'recurring_order', reducer })

      cb(null, Container)
    }, 'recurring_orders')
  }
})

export const EditRecurringOrderRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'recurring_orders/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditRecurringOrderContainer').default

      const actions = require('./modules/recurring_order').actions
      const reducer = require('./modules/recurring_order').default

      injectReducer(store, { key: 'recurring_order', reducer })

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'recurring_orders')
  }
})

export default function (store) {
  return [
    NewRecurringOrderRoute(store),
    EditRecurringOrderRoute(store),
    RecurringOrdersRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/RecurringOrders/index.js